// client/src/components/wetakeover/QRTSlider.jsx
import React from 'react';

const QRTSlider = ({ qrtsPerCreator, onQRTChange, numCreators }) => {
  const totalQRTs = numCreators * qrtsPerCreator;

  return (
    <div className="ui-motion-enter space-y-8 max-w-3xl mx-auto">
      <div className="text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          <span className="text-yellow-300">Content</span> to Amplify
        </h2>
        <p className="text-white/70 text-lg">
          How many content will each creator QRT?
        </p>
      </div>

      {/* QRT Visual Cards */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((qrt) => (
          <button
            key={qrt}
            onClick={() => onQRTChange(qrt)}
            className={`aspect-square rounded-[24px] flex flex-col items-center justify-center transition-[color,background-color,border-color,transform] border-2 ${
              qrtsPerCreator === qrt
                ? 'bg-yellow-300 border-yellow-300 text-black motion-safe:scale-105 shadow-lg shadow-yellow-300/30'
                : 'bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20 text-white'
            }`}
          >
            <div className="text-4xl font-bold">{qrt}</div>
            <div className="text-xs mt-1 opacity-70">{qrt === 1 ? 'Content' : 'Contents'}</div>
          </button>
        ))}
      </div>

      {/* Total QRTs Display */}
      <div className="bg-gradient-to-r from-yellow-300/10 to-yellow-300/5 rounded-[32px] p-8 border border-yellow-300/20">
        <div className="text-center">
          <div className="text-white/70 mb-2">Total Campaign QRTs</div>
          <div className="text-6xl font-extrabold text-yellow-300">{totalQRTs}</div>
          <div className="text-sm text-white/50 mt-3">
            {numCreators} creators × {qrtsPerCreator} {qrtsPerCreator === 1 ? 'content' : 'contents'}{' '}
            each
          </div>
        </div>
      </div>

      {/* Recommended Options */}
      <div className="bg-white/5 rounded-[24px] p-6 border border-white/10">
        <div className="text-sm text-white/70 mb-3">💡 Recommended:</div>
        <ul className="space-y-2 text-sm">
          <li className="flex items-start gap-2">
            <span className="text-yellow-300">•</span>
            <span>
              <strong>1-3 Contents:</strong> Subtle amplification, organic feel
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-yellow-300">•</span>
            <span>
              <strong>4-7 Contents:</strong> Strong campaign presence
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-yellow-300">•</span>
            <span>
              <strong>8-10 Contents:</strong> Maximum visibility push
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default QRTSlider;
